import * as React from 'react'
import {createStyles, TableCell, Theme, WithStyles, withStyles, Card, CardHeader, CardContent, Table, TableRow, TableBody, Icon, Tooltip} from '@material-ui/core'
import {compose} from 'redux'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import autobind from 'autobind-decorator'
import { RouteComponentProps, withRouter } from 'react-router'
import { formatDate } from 'src/core/i18n/date'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { paramsFrame } from 'src/shared/Cotation/Params'
import { CtxCotation, withCotation } from 'src/page/Consumer/Cotation/CotationProvider'
import { updateCotation } from 'src/core/redux/action/cotationAction'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/type/lib/withToast'
import { formatCurrency } from 'src/shared/utils/helpers'

const styles = (t: Theme) => createStyles({
    card: {
        height: '100%',
        marginBottom: t.spacing.unit * 2
    },
    cardTitle: {
        fontSize: '1.2rem',
        textTransform: 'uppercase'
    },
    table: {    
        '& tbody tr td': {
            whiteSpace: 'normal'
        }
    },
    titleWpr: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    focusRow: {
        background: 'rgba(237, 28, 36, 0.16)'
    }
});

interface IProps extends WithI18n,
  WithToast,
  WithStyles<typeof styles>,
  RouteComponentProps<any>,
  WithGlobalProgress,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>,
  CtxCotation  {
}

class Params extends React.Component<IProps, {}> {

    render() {
        const {t, classes, formParams, match, detail} = this.props;

        return (
            <Card className={classes.card} style={{overflow: 'visible'}}>
                <CardHeader classes={{title: classes.cardTitle}}  title={
                    <div className={classes.titleWpr}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Icon style={{marginRight: '5px'}}>settings</Icon>
                            {t.Cotation_setting_params}
                        </div>
                    </div>
                } />
                <CardContent style={{overflow: 'visible'}}>
                    {formParams &&
                        <Table className={classes.table}>
                            <TableBody>
                                {paramsFrame[match.params.productType].map((p, i) => (
                                    <>
                                    {(this.shouldShowField(formParams, p) && !p.salesValue) &&
                                        <TableRow key={`row-${i}`} className={(detail!.focus && detail!.focus.length > 0 && detail!.focus.split(",").some(x => x === p.value)) ? classes.focusRow : ''}>
                                            <TableCell key={`lbl-${i}`}>
                                                {p.label}
                                                {p.helper && this.generateHelper(p.helper, formParams)}
                                                {p.description &&
                                                    <Tooltip title={p.description} placement="top" key={`tooltip-${i}`}>
                                                        <Icon style={{fontSize: '18px', color: '#9e9e9e', marginLeft: '4px'}} key={`tooltip-icon-${i}`}>info</Icon>
                                                    </Tooltip>
                                                } : 
                                            </TableCell>
                                            <TableCell key={`val-${i}`}>
                                                {this.showFormValues(formParams, p.value, p, i)}
                                            </TableCell>
                                        </TableRow>
                                    }
                                    </>
                                ))}
                            </TableBody>
                        </Table>
                    }
                </CardContent>
                <CardHeader classes={{title: classes.cardTitle}}  title={
                    <div className={classes.titleWpr}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Icon style={{marginRight: '5px'}}>monetization_on</Icon>
                            {t.Cotation_params_reserved_for_arkea}
                        </div>
                    </div>
                } />
                <CardContent style={{overflow: 'visible'}}>
                    {formParams &&
                        <Table className={classes.table}>
                            <TableBody>
                                {paramsFrame[match.params.productType].map((p, i) => (
                                    <>
                                    {p.salesValue &&
                                        <TableRow key={`row-${i}`}>
                                            <TableCell key={`lbl-${i}`}>
                                                {p.label}
                                                {p.description &&
                                                    <Tooltip title={p.description} key={`tooltip-${p.description}-${i}`} placement="top">
                                                        <Icon  key={`icon-${p.description}-${i}`} style={{fontSize: '18px', color: '#9e9e9e', marginLeft: '4px'}}>info</Icon>
                                                    </Tooltip>
                                                } : 
                                            </TableCell>
                                            <TableCell key={`val-${i}`}>
                                                {this.showFormValues(formParams, p.value, p, i)}
                                            </TableCell>
                                        </TableRow>
                                    }
                                    </>
                                ))}
                            </TableBody>
                        </Table>
                    }
                </CardContent>
            </Card>
        )
    }

    // Only for change product
    @autobind
    private generateHelper(helper, form){
        switch(helper){
            case 'sens-devise':
                if(form.sens && form.devise){
                    switch(form.sens){
                        case 'import':
                            return ` (Achat ${form.devise.toString().substring(4)})`;
                        case 'export':
                            return ` (Vente ${form.devise.toString().substring(4)})`;
                        default:
                            return ''
                    }
                } else {
                    return ''
                } 
            case 'montant-devise':
                return form.devise ? ` (${form.devise.toString().substring(4)})`: '';
            default: 
                return '';
        }
    }

    @autobind
    private shouldShowField(form: any, data: any){
        return data.displayCondition ? data.displayCondition(form) : true
    }

    @autobind
    private showFormValues(form, key, frame, index){
        const {t} = this.props;
        if(Array.isArray(key)){
            const valueLabels = [] as any;
            key.map(k => valueLabels.push(this.formatValue(form[k], frame.type)));
            console.log(valueLabels)
            return (
                <span key={index}>
                    {valueLabels.join(" - ")}
                </span>
            );
        } else {
            const value = form[key];
            if(value !== undefined){
                return (
                    <>  
                        <span style={{marginRight: '3px'}} key={`before-${index}`}>
                            {frame.before}
                        </span>
                        <span key={`value-${index}`}>
                            {(frame.type === "string" || frame.type === "number") &&
                                value
                            }
                            {frame.type === "currency" &&
                                formatCurrency(value)
                            }
                            {frame.type === "document" &&
                                <a href={value} target="_blank" style={{marginLeft: '3px'}}>
                                    <Icon style={{color: '#00c616'}}>insert_drive_file</Icon>
                                </a>
                            }
                            {frame.type === "date" && 
                                formatDate(new Date(value))
                            } 
                            {frame.type === "boolean" && 
                                <span>{value ? t.yes : t.no}</span>
                            }
                        </span>
                        <span style={{marginLeft: '3px'}} key={`after-${index}`}>
                            {frame.after}
                        </span>
                    </>
                )
            } else {
                return "-";
            }
        }
    }

    @autobind
    private formatValue(value, type){
        switch(type){
            case "currency":
                return formatCurrency(value);
            case "date":
                return formatDate(new Date(value));
            case "document":
                return (
                    <a href={value} target="_blank" style={{marginLeft: '3px'}}>
                        <Icon style={{color: '#00c616'}}>insert_drive_file</Icon>
                    </a>
                );
            default:
                return value;
        }
    }


}

const state2props = (state: RootState) => ({
    connectedUser: state.accountInfo.connectedUser,
})

const dispatch2props = (dispatch: any) => ({
    saveCotation: (data: any, productType: string, id: string) => dispatch(updateCotation(data, productType, id))
})

export default compose(
    withCotation,
    withI18n,
    withToast,
    withRouter,
    withGlobalProgress,
    withStyles(styles),
    connect(state2props, dispatch2props)
)(Params)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotation/Params.tsx